export const CATALOG_IMAGE_RESPONSIVE_SIZES = {
  tiny: 320,
  small: 700,
  medium: 600,
  large: 408
};
